module.exports = __webpack_public_path__ + "img/5.6986bca3.jpg";